import * as z from "zod";

// What the create page hands the sheet page through router state: the grade
// token the server returns once, and the print name, which never leaves the
// browser. Neither is in the URL, so a copied link carries neither.
export const sheetHandoffSchema = z.object({
  gradeToken: z.string().optional(),
  printName: z.string().optional(),
});

export type SheetHandoff = z.infer<typeof sheetHandoffSchema>;

export function readSheetHandoff(state: unknown): SheetHandoff {
  const parsed = sheetHandoffSchema.safeParse(state);
  return parsed.success ? parsed.data : {};
}
